import {
  Component,
  forwardRef,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  HostListener,
  AfterContentChecked,
} from '@angular/core'
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms'

export const CUSTOM_INPUT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DynamicInputComponent),
  multi: true,
}

@Component({
  selector: 'ptr-dynamic-input',
  templateUrl: './dynamic-input.component.html',
  styleUrls: ['./dynamic-input.component.scss'],
  providers: [CUSTOM_INPUT_VALUE_ACCESSOR],
  standalone: false,
})
export class DynamicInputComponent
  implements ControlValueAccessor, AfterContentChecked
{
  @ViewChild('txtarea') txtAreaElement: ElementRef
  elementInputValue = ''
  isTextAreaActive = false
  onChange: any = () => {}
  onTouch: any = () => {}

  constructor(private cdr: ChangeDetectorRef) {}
  ngAfterContentChecked(): void {
    // once content is finalised check if the form elements already contain new line characters, if so - switch them for textareas
    if (this.elementInputValue && this.elementInputValue.length > 0) {
      if (this.elementInputValue.split('\n').length > 1) {
        this.isTextAreaActive = true
      }
    }
  }

  createNewline(event) {
    const newLineString = [
      this.elementInputValue.slice(0, event.target.selectionStart),
      '\n',
      this.elementInputValue.slice(event.target.selectionStart),
    ].join('')
    this.value = newLineString
    if (!this.isTextAreaActive) {
      this.setTextAreaActive(event.target.selectionStart + 1)
    }
    this.cdr.detectChanges() // force a change detection for the possible rendering of a different input element (input/textarea)
  }

  setTextAreaActive(selectionPos: number) {
    this.isTextAreaActive = true
    window.setTimeout(() => {
      // need timeout for when an element has just turned visible
      this.txtAreaElement.nativeElement.focus()
      this.txtAreaElement.nativeElement.setSelectionRange(
        selectionPos,
        selectionPos,
      )
    }, 0)
  }

  set value(val) {
    if (val !== null && this.elementInputValue !== val) {
      if (val.includes('\\n')) {
        const preparsedValue = val.split('\\n')
        val = preparsedValue.join('\n')
        this.setTextAreaActive(0)
        // if the input has \n - first preparse those back to actual new lines for the text area, then force the textarea to be visible.
      }
      this.elementInputValue = val
      this.onChange(val)
      this.onTouch(val)
    }
  }

  writeValue(value: any) {
    this.value = value
  }

  registerOnChange(fn: any) {
    this.onChange = fn
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn
  }
}
